import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AppProvider } from './contexts/AppContext';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { TourProvider } from './contexts/TourContext';
import { AnalysisProvider } from './contexts/AnalysisContext';
import { TourOverlay } from './components/TourOverlay';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <BrowserRouter>
            <ThemeProvider>
                <AuthProvider>
                    <AppProvider>
                        <AnalysisProvider>
                            <TourProvider>
                                <App />
                                <TourOverlay />
                            </TourProvider>
                        </AnalysisProvider>
                    </AppProvider>
                </AuthProvider>
            </ThemeProvider>
        </BrowserRouter>
    </React.StrictMode>
);

